module.exports = __webpack_public_path__ + "img/noimg.e96edd0b.png";